const { arrayOf, string, bool, shape, number } = require('prop-types');
const associateSpec = require('./associate.spec');
const imageSpec = require('./image.spec');
const officeSpec = require('./office.spec');
const phoneSpec = require('./phone.spec');
const stateSpec = require('./state.spec');

module.exports = {
  active: bool,
  isRemote: bool,
  queryType: string,
  queryValue: string,
  alias: string,
  aliasPath: string,
  webId: string,
  rid: string,
  email: string,
  repNum: string,
  type: string,
  nNumber: string,
  firstName: string,
  lastName: string,
  preferredName: string,
  displayName: string,
  bio: string,
  qualification: string,
  firstPartyReviewPage: string,
  googlePlaceId: string,
  title: string,
  quote: string,
  videoUrl: string,
  services: arrayOf(string),
  products: arrayOf(string),
  education: arrayOf(string),
  social: shape({
    facebook: string,
    instagram: string,
    linkedin: string,
    twitter: string,
  }),
  image: shape(imageSpec),
  primaryPhone: shape({
    number: string.isRequired,
    extension: string,
  }),
  phones: shape(phoneSpec),
  licenses: shape({
    states: arrayOf(shape({ stateSpec })),
    licenseNumbers: arrayOf(string.isRequired),
  }),
  languages: arrayOf(
    shape({
      language: string.isRequired,
    }),
  ),
  awards: arrayOf(
    shape({
      title: string.isRequired,
      description: string.isRequired,
    }),
  ),
  associates: arrayOf(shape(associateSpec)),
  tags: shape({
    inclusions: arrayOf(string.isRequired),
    exclusions: arrayOf(string.isRequired),
  }),
  offices: arrayOf(shape(officeSpec)),
  localOffice: shape({
    street: string.isRequired,
    additionalStreetInfo: string,
    city: string.isRequired,
    zip: string.isRequired,
    state: shape(stateSpec).isRequired,
  }),
  localOfficeCoordinates: arrayOf(number.isRequired),
  landingPage: string,
  rating: number,
  reviews: arrayOf(
    shape({
      id: number,
      isHidden: bool,
      status: string,
      flagStatus: string,
      url: string,
      rating: number,
      content: string,
      authorName: string,
      publisherDate: number,
      reviewLanguage: string,
      comments: arrayOf(shape({
        id: number,
        publisherDate: number,
        authorName: string,
        authorRole: string,
        authorEmail: string,
        content: string,
        visibility: string,
      }))
    }),
  ),
};
